<div class="user-cell">
    <img class="img-avatar" [src]="imgSrc" [alt]="userName" />
    <span class="user-name">{{ userName }}</span>
</div>